import { Card, Stack, Typography, CardContent } from '@mui/material';
import { useState, useEffect, useCallback } from 'react';
import axios, { endpoints } from 'src/utils/axios';
import { toastError } from 'src/utils/format-error';
import { useBoolean } from 'src/hooks/use-boolean';
import { UserType } from 'src/type/user';
import { PositionTxType } from 'src/type/position';
import OpenedPositionTable from '../../components/opened-position-table';

type Props = {
  user: UserType;
};

export default function OpenedPosition({ user }: Props) {
  const initialize = useBoolean(true);

  const [openedPositions, setOpenedPositions] = useState();

  const getOpenedPosition = useCallback(async () => {
    try {
      initialize.onTrue();

      if (!user) return;

      const { data } = await axios.get(endpoints.transactions.position.open, {
        params: { userId: user.uid },
      });

      setOpenedPositions(data);
    } catch (error) {
      toastError(error);
    } finally {
      initialize.onFalse();
    }
  }, []);

  useEffect(() => {
    getOpenedPosition();
  }, []);

  return (
    <>
      {openedPositions &&
        Object.entries(
          openedPositions as Record<
            string,
            {
              product: { name: string; isOrnament: boolean; sequence?: number };
              infos: {
                buyAmount: number;
                sellAmount: number;
                netAmount: number;
                buyTotal: number;
                sellTotal: number;
                netTotal: number;
              };
              userTransactions: PositionTxType[];
            }
          >
        )
          .sort((a, b) => {
            const sequenceA = a[1]?.product?.sequence ?? 999;
            const sequenceB = b[1]?.product?.sequence ?? 999;
            return sequenceA - sequenceB;
          })
          .map(([key, value], index) => (
            <Card key={index}>
              <CardContent>
                <Stack spacing={3}>
                  <Stack spacing={2}>
                    <Stack direction="row" alignItems="flex-end" justifyContent="space-between">
                      <Typography variant="subtitle1">รายการคงค้าง {value.product.name}</Typography>
                    </Stack>

                    <OpenedPositionTable
                      isOrnament={value.product.isOrnament}
                      infos={value.infos}
                      userTransactions={value.userTransactions}
                    />
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
          ))}
    </>
  );
}
